import request from '@/utils/request'

// 获取学段年级的列表
export const getGradeLists = (data) => {
    return request({
        url: '/grade/lists',
        params: data
    })
}

// 获取学段年级的选项列表
export const getGradeOptionLists = (data) => {
    return request({
        url: '/grade/option/lists',
        params: data
    })
}

// 获取学段年级的树形菜单
export const getGradeTreeLists = () => {
    return request({
        url: '/grade/tree'
    })
}

// 年级-详情
export const getGradeDetail = (id) => {
    return request({
        url: `/grade/${id}`
    })
}

// 年级-修改
export const putGradeModel = (data) => {
    return request({
        url: '/grade/manage',
        method: 'PUT',
        data
    })
}

// 年级-添加
export const addGradeModel = (data) => {
    return request({
        url: '/grade/manage',
        method: 'POST',
        data
    })
}

// 年级-删除
export const delGradeModel = (id) => {
    return request({
        url: `/grade/${id}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/grade/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/grade/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}
// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/grade/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
